var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 22.2012C16.6 20.9512 13.4 20.9512 10.7 22.2012C10.05 22.5012 10.85 24.3012 11.55 23.9512C13.35 23.1012 16 22.8012 18.5 23.9512C19.15 24.2512 20 22.5512 19.3 22.2012Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14.5C26 17 24 19 21.5 19C19 19 17 17 17 14.5C17 12 19 10 21.5 10C24 10 26 12 26 14.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.5C23.1569 17.5 24.5 16.1569 24.5 14.5C24.5 12.8431 23.1569 11.5 21.5 11.5C19.8431 11.5 18.5 12.8431 18.5 14.5C18.5 16.1569 19.8431 17.5 21.5 17.5Z",
    fill: "#664E27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 18.3514C23.0732 18.3514 23.7 17.635 23.7 16.7514C23.7 15.8677 23.0732 15.1514 22.3 15.1514C21.5268 15.1514 20.9 15.8677 20.9 16.7514C20.9 17.635 21.5268 18.3514 22.3 18.3514Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 15.4508C20.8418 15.4508 21.2 15.0255 21.2 14.5008C21.2 13.9761 20.8418 13.5508 20.4 13.5508C19.9582 13.5508 19.6 13.9761 19.6 14.5008C19.6 15.0255 19.9582 15.4508 20.4 15.4508Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.501C13 17.001 11 19.001 8.50002 19.001C6.00002 19.001 4.00002 17.001 4.00002 14.501C4.00002 12.001 6.00002 10.001 8.50002 10.001C11 10.001 13 12.001 13 14.501Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5C10.1569 17.5 11.5 16.1569 11.5 14.5C11.5 12.8431 10.1569 11.5 8.5 11.5C6.84315 11.5 5.5 12.8431 5.5 14.5C5.5 16.1569 6.84315 17.5 8.5 17.5Z",
    fill: "#664E27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29999 18.3504C10.0732 18.3504 10.7 17.634 10.7 16.7504C10.7 15.8667 10.0732 15.1504 9.29999 15.1504C8.5268 15.1504 7.89999 15.8667 7.89999 16.7504C7.89999 17.634 8.5268 18.3504 9.29999 18.3504Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39999 15.4498C7.84182 15.4498 8.19999 15.0245 8.19999 14.4998C8.19999 13.9751 7.84182 13.5498 7.39999 13.5498C6.95816 13.5498 6.59999 13.9751 6.59999 14.4998C6.59999 15.0245 6.95816 15.4498 7.39999 15.4498Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17C19.95 20.4 18.5 23.5 18.5 26.05C18.5 28.25 20.3 30 22.5 30C24.7 30 26.5 28.25 26.5 26.05C26.5 23.5 25 20.35 22.5 17Z",
    fill: "#65B1EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 9.34934C24 7.99934 21.85 7.39934 19.75 7.79934C19.45 7.84934 19.2 6.79934 19.55 6.69934C21.95 6.24934 24.45 6.94934 26.3 8.49934C26.6 8.74934 25.8 9.54934 25.6 9.34934ZM10.25 7.69934C8.15 7.34934 6 7.89934 4.4 9.24934C4.2 9.44934 3.4 8.64934 3.7 8.39934C5.55 6.79934 8.05 6.14934 10.45 6.59934C10.8 6.69934 10.55 7.74934 10.25 7.69934Z",
    fill: "#917524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/Emoji.b0c4715618ce1d1ed1e3da659e74bf3a.svg";
export { ForwardRef as ReactComponent };